import React from 'react';

export default ({ className }) => (
  <svg className={className} viewBox='0 0 30 23' fill='none'>
    <path
      fill='currentColor'
      d='M27.6,9.3h-0.3V0H2.7v9.3H2.4C1.1,9.3,0,10.4,0,11.7v4V17v1.5v1.2V23h1.2v-3.2h3.2h21.3h3.2V23H30v-3.2v-1.2V17v-1.2v-4
	C30,10.4,28.9,9.3,27.6,9.3z M28.8,15.7H1.2v-4c0-0.7,0.5-1.2,1.2-1.2h0.3h2.5h9.3h1.1h9.3h2.5h0.3c0.7,0,1.2,0.6,1.2,1.2V15.7z
	 M3.9,1.2h22.2v8h-1.3V7.4c0-1.6-1.2-2.8-2.7-2.8h-3.8c-1.5,0-2.7,1.3-2.7,2.8v1.8h-1.1V7.4c0-1.6-1.2-2.8-2.7-2.8H7.9
	c-1.5,0-2.7,1.3-2.7,2.8v1.8H3.9V1.2z M23.6,9.3h-6.9V7.4c0-0.9,0.7-1.6,1.5-1.6h3.8c0.8,0,1.5,0.7,1.5,1.6V9.3z M6.4,7.4
	c0-0.9,0.7-1.6,1.5-1.6h3.8c0.8,0,1.5,0.7,1.5,1.6v1.8H6.4V7.4z M28.8,18.5h-3.2H4.3H1.2V17h27.6V18.5z'
    />
  </svg>
);
